import { Autocomplete } from '@react-google-maps/api';
import { DEFAULT_OPTIONS } from './constants';
import { Input } from './styled';
import { GooglePlacesAutocompleteProps } from './types';
import useController from './useController';
import '@/styles/google-places-autocomplete.css';

const GooglePlacesAutocomplete = ({ onPlaceSelect, ...props }: GooglePlacesAutocompleteProps) => {
  const { googleMapsLoaded, handlePlaceChanged, inputRef, onLoad, setValue, value } = useController({
    onPlaceSelect,
  });

  if (!googleMapsLoaded) return null;

  return (
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={handlePlaceChanged}
      options={DEFAULT_OPTIONS}
      className="address-lookup"
      {...props}
    >
      <Input
        ref={inputRef}
        aria-label="Google address lookup"
        placeholder="Google Maps Address Search"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
      />
    </Autocomplete>
  );
};

export default GooglePlacesAutocomplete;
